import { type ReactNode } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@tempmee/react';

export interface IBidNomineeTableProps {
  /** The {@link BidNomineeRow}s to list, one per nominee. */
  children: ReactNode;
  'data-cy'?: string;
}

/** The nominees table's column headers, in render order. */
const COLUMNS = ['Professional', 'Office', 'Complete Survey'] as const;

/**
 * The Best in Dental nominees table — the `<table>` shell and its column
 * headers. Holds no data of its own; the tab maps its rows into
 * {@link BidNomineeRow} children.
 */
export const BidNomineeTable = ({ children, 'data-cy': dataCy }: IBidNomineeTableProps) => (
  <TableContainer data-cy={dataCy}>
    <Table>
      <TableHead>
        <TableRow>
          {COLUMNS.map((column) => (
            <TableCell key={column} className="text-primary">
              {column}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>{children}</TableBody>
    </Table>
  </TableContainer>
);
